import { useAuth } from '@providers/AuthProvider';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MaestroLoader from '@components/MaestroLoader';
import { Stack } from '@mui/joy';
import { useTenant } from '@providers/TenantProvider';
import UnrecoverableError, { Error } from '@components/UnrecoverableError';
import { isConductor } from '@utils/tenant';
import { maestroLogo } from '@utils/assets';

export default function EnsureValidTenant({children}) {
  const {
    tenant,
    isLoading,
    isNotFound,
    isInactive
  } = useTenant();

  useEffect(() => {
    if(isLoading) {
      return;
    }

  }, [isLoading, tenant]);

  if(isConductor) {
    return children;
  }

  if(isNotFound) {
    return (
      <Error>
      <b>The account you are looking for does not exist.</b>
      <br/>
      Please double check that you typed the URL correctly.
      <br/>
    </Error>)
  }

  if(isInactive) {
    return <Error><b>The account you are looking for is inactive.</b></Error>
  }

  if(isLoading) {
    return (
      <Stack alignItems={'center'} justifyContent={'center'} gap={4} height={'100vh'}>
        <img
          src={maestroLogo}
          alt="Maestro Logo"
          style={{width: '300px', minWidth: '100px'}}
        />
        <MaestroLoader/>
      </Stack>
    );
  }

  return children;
}
